import { Injectable } from '@angular/core';
import { Column, ControlListenerPlugin } from '@miq/catalog';
import { Store } from '@ngxs/store';
import { ErrorMessengerService } from '@records/controls/services/error-messenger.service';
import { MessageItemLevel, MessageItemType } from '@records/state/message-center/message-center.model';
import { AbstractErrorMessengerListener } from './abstract-error-messenger.service';

@Injectable()
export class ColumnErrorMessengerListenerService
  extends AbstractErrorMessengerListener<Column>
  implements ControlListenerPlugin<Column>
{
  private _symbol = Symbol('__ColumnErrorMessengerListenerService');
  constructor(store: Store) {
    super(store);
  }
  get symbol() {
    return this._symbol;
  }

  protected makeErrorService(config: Column): ErrorMessengerService {
    return new ErrorMessengerService(this.store, MessageItemLevel.columns, config.columnId, MessageItemType.error);
  }
}
